// src/components/common/BottomNav.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Package, User } from 'lucide-react';

const navItems = [
  { path: '/driver', icon: Home, label: 'Accueil' },
  { path: '/driver/missions', icon: Package, label: 'Livraisons' },
  { path: '/driver/profile', icon: User, label: 'Profil' },
];

const BottomNav = () => {
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/driver') {
      return location.pathname === '/driver' || location.pathname === '/driver/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50">
      {/* Glass background */}
      <div className="absolute inset-0 bg-white/80 backdrop-blur-xl border-t border-gray-200/50" />

      {/* Safe area padding for iOS */}
      <div className="relative px-2 pb-safe">
        <div className="flex justify-around items-center h-16">
          {navItems.map((item) => {
            const active = isActive(item.path);
            const Icon = item.icon;

            return (
              <Link
                key={item.path}
                to={item.path}
                className="relative flex flex-col items-center justify-center w-16 h-full"
              >
                {/* Active indicator */}
                {active && (
                  <motion.div
                    layoutId="bottomNavIndicator"
                    className="absolute -top-0.5 w-8 h-1 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-full"
                    transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                  />
                )}

                {/* Icon container */}
                <motion.div
                  whileTap={{ scale: 0.9 }}
                  className={`relative flex items-center justify-center w-10 h-10 rounded-xl transition-colors ${
                    active
                      ? 'bg-emerald-50'
                      : 'bg-transparent'
                  }`}
                >
                  <Icon
                    className={`w-5 h-5 transition-colors ${
                      active
                        ? 'text-emerald-600'
                        : 'text-gray-400'
                    }`}
                  />

                  {/* Notification badge example */}
                  {item.path === '/driver/missions' && (
                    <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                      3
                    </span>
                  )}
                </motion.div>

                {/* Label */}
                <span
                  className={`text-[10px] font-medium mt-0.5 transition-colors ${
                    active
                      ? 'text-emerald-600'
                      : 'text-gray-400'
                  }`}
                >
                  {item.label}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNav;
